import { useOrganisationSwitch } from "../../auth/OrganisationSwitchProvider";
import { DateProvider } from "./DateContext";

/**
 * Feeds the organisation's configured time zone into the date config.
 *
 * `DateProvider` was mounted above `OrganisationSwitchProvider` with no value,
 * so every date in the app — displayed, and the calendar-date conversions that
 * decide which day gets saved — resolved against whatever zone the *browser*
 * happened to be in. The organisation setting existed and was editable, and
 * nothing read it.
 *
 * Until the organisation's record loads, `organisationTimeZone` is null and the
 * provider falls back to its own default (the browser's zone). That is the
 * right fallback: it matches the previous behaviour, and it is better than
 * guessing a fixed zone for an organisation that hasn't identified itself yet.
 */
export function OrgDateProvider({ children }: { children: React.ReactNode }) {
  const { organisationTimeZone } = useOrganisationSwitch();

  return (
    <DateProvider
      value={
        organisationTimeZone ? { timezone: organisationTimeZone } : undefined
      }
    >
      {children}
    </DateProvider>
  );
}
